import React from 'react';
import { Dropdown } from '@instinet-analytics/semantic-ui-components';

import { ColumnDefinitionsDictionary } from '@instinet-analytics/semantic-ui-components';
import { EditedColumnNames } from 'grid/columnNames/hooks';

interface FilterColumnsDropdownProps<TColumnId extends string> {
    columnDefinitions: ColumnDefinitionsDictionary<TColumnId>;
    editedColumnNames?: EditedColumnNames;
    visibleColumns: TColumnId[];
    editingColumn: TColumnId | undefined;
    setEditingColumn: (column: TColumnId) => void;
    className?: string;
}

export default function FilterColumnsDropdown<TColumnId extends string>(
    props: FilterColumnsDropdownProps<TColumnId>
) {
    const {
        columnDefinitions,
        editedColumnNames,
        visibleColumns,
        editingColumn,
        setEditingColumn,
        className,
    } = props;

    const options = computeOptions(
        columnDefinitions,
        visibleColumns,
        editedColumnNames
    );
    const value = editingColumn ?? '';

    const onChange = (value: TColumnId | '') => {
        if (value) {
            setEditingColumn(value);
        }
    };

    return (
        <Dropdown
            value={value}
            onChange={onChange}
            options={options}
            className={className}
        />
    );
}

export function computeOptions<TColumnId extends string>(
    columnDefinitions: ColumnDefinitionsDictionary<TColumnId>,
    visibleColumns: TColumnId[],
    editedColumnNames?: EditedColumnNames
) {
    return visibleColumns.map((column) => ({
        key: column,
        value: column,
        text:
            (editedColumnNames ?? {})[column] ?? columnDefinitions[column].name,
    }));
}
